import { Box, Container, Typography } from "@mui/material";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import image from "../../assets/smart-sap.png";

const OurApproach = () => {
  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="lg">
        <Box sx={styles.wrapper}>
          {/* Content */}
          <Box sx={styles.content}>
            <Typography variant="h5" sx={styles.title}>
              <VerifiedOutlinedIcon sx={styles.titleIcon} />
              Our Approach
            </Typography>

            <Typography sx={styles.description}>
              We follow a strategic and customer-centric approach to design
              scalable supply chain ecosystems aligned with your operational
              goals.
            </Typography>

            <Typography sx={styles.subText}>
              Our team works closely with stakeholders to understand business
              challenges, optimize existing processes, and implement
              future-ready digital solutions that deliver measurable business
              outcomes.
            </Typography>
          </Box>

          {/* Img */}
          <Box sx={styles.imgWrapper}>
            <Box
              component="img"
              src={image}
              alt="SAP Silver Partner"
              sx={styles.img}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const styles = {
  section: {
    py: { xs: 4, md: 5 },
    overflow: "hidden",
  },

  wrapper: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "1.1fr 0.9fr",
    },
    alignItems: "center",
    gap: { xs: 6, md: 10 },
  },

  content: {
    display: "flex",
    flexDirection: "column",
  },

  title: {
    display: "flex",
    alignItems: "center",
    gap: 1.2,
    fontSize: {
      xs: "24px",
      sm: "30px",
      md: "38px",
    },
    fontWeight: 800,
    color: "#111827",
    mb: 3,
    lineHeight: 1.2,
  },

  titleIcon: {
    fontSize: 30,
    color: "#00c853",
  },

  description: {
    fontSize: {
      xs: "14px",
      md: "16px",
    },
    lineHeight: 1.9,
    color: "#4b5563",
    mb: 2.5,
    textAlign: "justify",
    maxWidth: 650,
  },

  subText: {
    fontSize: {
      xs: "14px",
      md: "16px",
    },
    lineHeight: 1.9,
    color: "#6b7280",
    textAlign: "justify",
    maxWidth: 650,
  },

  imgWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: {
      xs: "center",
      md: "flex-end",
    },

    width: "100%",
    height: "100%",

    borderRadius: "28px",
    overflow: "hidden",

    background:
      "linear-gradient(135deg, rgba(7,21,37,0.04) 0%, rgba(0,200,83,0.03) 100%)",

    border: "1px solid rgba(0,0,0,0.05)",

    boxShadow: "0 20px 60px rgba(0,0,0,0.08)",

    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(circle at top right, rgba(0,200,83,0.12), transparent 35%)",
      zIndex: 0,
    },
  },

  img: {
    position: "relative",
    zIndex: 1,

    width: "100%",
    height: "100%",

    objectFit: "cover",
    display: "block",

    transition: "transform 0.5s ease",

    "&:hover": {
      transform: "scale(1.03)",
    },
  },
};

export default OurApproach;
